(function () {
  'use strict';
  const db = () => window.SM.DB;
  const ui = () => window.SM.UI;
  const util = () => window.SM.UTIL;
  const canSeeCost = () => window.SM.AUTH.canSeeCost();
  const isAdmin = () => window.SM.AUTH.isAdmin();

  let _activeTab = 'catalogue';

  // ─── INIT TABS ───────────────────────────────────────────────────
  function initTabs() {
    const tabs = document.getElementById('ims-inv-tabs');
    if (!tabs) return;
    tabs.querySelectorAll('.ims__tab').forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.querySelectorAll('.ims__tab').forEach(t => t.classList.remove('ims__tab--active'));
        tab.classList.add('ims__tab--active');
        _activeTab = tab.dataset.tab;
        loadTab(_activeTab);
      });
    });
  }

  function loadTab(tab) {
    if (tab === 'catalogue') loadCatalogue();
    else loadStock();
  }

  // ═══════════════════════════════════════════════════════════════
  // TAB 1 — PRODUCT CATALOGUE
  // ═══════════════════════════════════════════════════════════════
  async function loadCatalogue() {
    const content = document.getElementById('ims-inv-content');
    if (!content) return;

    const actions = document.getElementById('ims-inv-actions');
    if (actions) {
      actions.innerHTML = `
        <button class="ims__btn ims__btn--secondary" id="ims-cat-export-btn"><i class="ti ti-download"></i> Export</button>
        <button class="ims__btn ims__btn--secondary" id="ims-cat-import-btn"><i class="ti ti-upload"></i> Import SKUs</button>
        <button class="ims__btn ims__btn--primary" id="ims-cat-new-btn"><i class="ti ti-plus"></i> Add new SKU</button>`;
      document.getElementById('ims-cat-new-btn')?.addEventListener('click', () => showSKUForm());
      document.getElementById('ims-cat-import-btn')?.addEventListener('click', showImport);
      document.getElementById('ims-cat-export-btn')?.addEventListener('click', exportProducts);
    }

    content.innerHTML = `
      <div class="ims__alert ims__alert--info" style="margin-bottom:14px">
        <i class="ti ti-info-circle"></i>
        <span><strong>Product Catalogue</strong> — Define your products here first. Stock is managed separately in the Stock Levels tab.</span>
      </div>
      <div class="ims__filters">
        <div class="ims__search-wrap"><i class="ti ti-search"></i><input class="ims__input" type="text" id="ims-cat-search" placeholder="Name, SKU, barcode, category..."></div>
        <select class="ims__select" id="ims-cat-category"><option value="">All categories</option></select>
        <select class="ims__select" id="ims-cat-status"><option value="">All products</option><option value="active">Active</option><option value="inactive">Inactive</option></select>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr>
              <th>SKU</th><th>Product name</th><th>Category</th><th>Unit</th>
              ${canSeeCost() ? '<th>Cost price</th>' : ''}
              <th>Wholesale</th><th>RRP</th><th>Boxes</th><th>Reorder at</th><th>Status</th><th></th>
            </tr></thead>
            <tbody id="ims-cat-tbody"><tr><td colspan="${canSeeCost()?11:10}" class="ims__table-empty"><i class="ti ti-loader-2 ims__spin"></i></td></tr></tbody>
          </table>
        </div>
      </div>`;

    const searchEl = document.getElementById('ims-cat-search');
    if (searchEl) searchEl.addEventListener('input', util().debounce(loadCatalogueData, 350));
    document.getElementById('ims-cat-category')?.addEventListener('change', loadCatalogueData);
    document.getElementById('ims-cat-status')?.addEventListener('change', loadCatalogueData);

    await loadCatalogueData();
  }

  async function loadCatalogueData() {
    const tbody = document.getElementById('ims-cat-tbody');
    if (!tbody) return;
    const search   = document.getElementById('ims-cat-search')?.value?.trim() || '';
    const category = document.getElementById('ims-cat-category')?.value || '';
    const status   = document.getElementById('ims-cat-status')?.value || '';

    const { data: products, error } = await db().select('products', { order: { col: 'name' } });
    if (error) { ui().toast('Failed to load catalogue', 'error'); return; }

    let items = products || [];
    if (search) {
      const s = search.toLowerCase();
      items = items.filter(p => p.name?.toLowerCase().includes(s) || p.sku?.toLowerCase().includes(s) || p.category?.toLowerCase().includes(s) || p.barcode?.toLowerCase().includes(s));
    }
    if (category) items = items.filter(p => p.category === category);
    if (status === 'active')   items = items.filter(p => p.is_active !== false);
    if (status === 'inactive') items = items.filter(p => p.is_active === false);

    const catSel = document.getElementById('ims-cat-category');
    if (catSel && catSel.options.length <= 1) {
      const cats = [...new Set((products||[]).map(p => p.category).filter(Boolean))].sort();
      cats.forEach(c => { const o = document.createElement('option'); o.value = c; o.textContent = c; catSel.appendChild(o); });
    }

    if (!items.length) {
      tbody.innerHTML = `<tr><td colspan="${canSeeCost()?11:10}" class="ims__table-empty">No products in catalogue yet — click <strong>Add new SKU</strong> to start</td></tr>`;
      return;
    }

    // Batch load prices
    const priceMap = {};
    const productIds = items.map(p => p.id);
    const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
    const { data: allPrices } = await client
      .from('product_prices')
      .select('product_id, price_type, price')
      .in('product_id', productIds)
      .is('platform_id', null);
    (allPrices || []).forEach(pp => {
      if (!priceMap[pp.product_id]) priceMap[pp.product_id] = { cost: null, wholesale: null, rrp: null };
      priceMap[pp.product_id][pp.price_type] = pp.price;
    });

    // Batch load box counts
    const boxCountMap = {};
    const { data: allBoxes } = await client
      .from('product_boxes')
      .select('product_id')
      .in('product_id', productIds);
    (allBoxes || []).forEach(b => {
      boxCountMap[b.product_id] = (boxCountMap[b.product_id] || 0) + 1;
    });

    tbody.innerHTML = items.map(p => {
      const pr = priceMap[p.id] || {};
      const boxCount = boxCountMap[p.id] || 0;
      return `<tr>
        <td><span class="ims__link" onclick="window.IMS_INVENTORY.openSKU('${p.id}')">${util().sanitize(p.sku || '—')}</span></td>
        <td><span class="ims__link" onclick="window.IMS_INVENTORY.openSKU('${p.id}')">${util().sanitize(p.name)}</span></td>
        <td>${util().sanitize(p.category || '—')}</td>
        <td>${util().sanitize(p.unit || 'each')}</td>
        ${canSeeCost() ? `<td>${pr.cost !== null && pr.cost !== undefined ? util().formatCurrency(pr.cost) : '<span style="color:var(--ims-warning)">Not set</span>'}</td>` : ''}
        <td>${pr.wholesale !== null && pr.wholesale !== undefined ? util().formatCurrency(pr.wholesale) : '<span style="color:var(--ims-warning)">Not set</span>'}</td>
        <td>${pr.rrp !== null && pr.rrp !== undefined ? util().formatCurrency(pr.rrp) : '<span style="color:var(--ims-warning)">Not set</span>'}</td>
        <td>${boxCount > 0 ? `<span class="ims__pill ims__pill--info">${boxCount} box${boxCount>1?'es':''}</span>` : '<span style="color:var(--ims-text-muted);font-size:11px">Not set</span>'}</td>
        <td>${p.reorder_threshold || 10}</td>
        <td><span class="ims__pill ims__pill--${p.is_active !== false ? 'success' : 'neutral'}">${p.is_active !== false ? 'Active' : 'Inactive'}</span></td>
        <td>
          <div class="ims__btn-group">
            <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_INVENTORY.openSKU('${p.id}')" title="View"><i class="ti ti-eye"></i></button>
            ${isAdmin() ? `<button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_INVENTORY.showSKUForm('${p.id}')" title="Edit"><i class="ti ti-edit"></i></button>` : ''}
            ${canSeeCost() ? `<button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_INVENTORY.managePlatformPrices('${p.id}','${util().sanitize(p.name)}')" title="Platform prices"><i class="ti ti-apps"></i></button>` : ''}
            ${isAdmin() ? `<button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_INVENTORY.deleteSKU('${p.id}','${util().sanitize(p.name)}')" title="Delete product"><i class="ti ti-trash"></i></button>` : ''}
          </div>
        </td>
      </tr>`;
    }).join('');
  }

  // ─── SKU DETAIL VIEW ─────────────────────────────────────────────
  async function openSKU(id) {
    const { data: p } = await db().select('products', { eq: { id }, maybeSingle: true, noCompanyFilter: true });
    if (!p) return;
    const prices = await db().getProductPrices(id);
    const cost      = prices.find(x => x.price_type === 'cost' && !x.platform_id)?.price;
    const wholesale = prices.find(x => x.price_type === 'wholesale' && !x.platform_id)?.price;
    const rrp       = prices.find(x => x.price_type === 'rrp' && !x.platform_id)?.price;
    const platPrices= prices.filter(x => x.price_type === 'platform');

    const { data: stock } = await db().select('stock_levels', {
      select: 'quantity,reserved_qty,reserved_by_allocations,bin_reference,warehouses(name)',
      eq: { product_id: id }, noCompanyFilter: true
    });
    const onHand    = (stock||[]).reduce((s, l) => s + (l.quantity||0), 0);
    const reserved  = (stock||[]).reduce((s, l) => s + (l.reserved_qty||0), 0);
    const allocated = (stock||[]).reduce((s, l) => s + (l.reserved_by_allocations||0), 0);

    // Load boxes
    const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
    const { data: boxes } = await client
      .from('product_boxes')
      .select('*')
      .eq('product_id', id)
      .order('box_number');
    const boxList = boxes || [];
    const totalWeight = boxList.reduce((s, b) => s + (b.weight_kg || 0), 0);
    const totalVol = boxList.reduce((s, b) => {
      const vol = ((b.length_cm||0) * (b.width_cm||0) * (b.height_cm||0)) / 5000;
      return s + vol;
    }, 0);

    ui().openModal(`SKU: ${p.name}`, `
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
        <div><span class="ims__label">SKU</span><div style="font-weight:700;font-size:18px">${util().sanitize(p.sku || '—')}</div></div>
        <div><span class="ims__label">Category</span><div>${util().sanitize(p.category || '—')}</div></div>
        <div><span class="ims__label">Barcode</span><div>${util().sanitize(p.barcode || '—')}</div></div>
        <div><span class="ims__label">Unit of measure</span><div>${util().sanitize(p.unit || 'each')}</div></div>
        <div><span class="ims__label">Reorder threshold</span><div>${p.reorder_threshold || 10} units</div></div>
        <div><span class="ims__label">Reorder quantity</span><div>${p.reorder_quantity || 50} units</div></div>
        <div><span class="ims__label">Default bin</span><div>${util().sanitize(p.default_bin || '—')}</div></div>
        <div><span class="ims__label">Status</span><div><span class="ims__pill ims__pill--${p.is_active!==false?'success':'neutral'}">${p.is_active!==false?'Active':'Inactive'}</span></div></div>
        ${p.notes ? `<div style="grid-column:1/-1"><span class="ims__label">Notes</span><div>${util().sanitize(p.notes)}</div></div>` : ''}
      </div>
      <hr class="ims__divider">
      <strong style="font-size:13px">Pricing</strong>
      <div style="display:grid;grid-template-columns:repeat(${canSeeCost()?3:2},1fr);gap:8px;margin:8px 0">
        ${canSeeCost() ? `<div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Cost price</div><div class="ims__stat-value" style="font-size:18px">${cost!==null&&cost!==undefined?util().formatCurrency(cost):'<span style="color:var(--ims-warning);font-size:13px">Not set</span>'}</div></div>` : ''}
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Wholesale price</div><div class="ims__stat-value" style="font-size:18px">${wholesale!==null&&wholesale!==undefined?util().formatCurrency(wholesale):'<span style="color:var(--ims-warning);font-size:13px">Not set</span>'}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">RRP</div><div class="ims__stat-value" style="font-size:18px">${rrp!==null&&rrp!==undefined?util().formatCurrency(rrp):'<span style="color:var(--ims-warning);font-size:13px">Not set</span>'}</div></div>
      </div>
      ${platPrices.length ? `
        <strong style="font-size:13px;display:block;margin:10px 0 6px">Platform-specific prices</strong>
        <table class="ims__table">
          <thead><tr><th>Platform</th><th>Price</th></tr></thead>
          <tbody>${platPrices.map(pp => `<tr><td>${util().sanitize(pp.platforms?.name||'—')}</td><td>${util().formatCurrency(pp.price)}</td></tr>`).join('')}</tbody>
        </table>` : ''}
      <hr class="ims__divider">
      <strong style="font-size:13px">Packaging</strong>
      ${boxList.length ? `
        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin:8px 0">
          <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total boxes</div><div class="ims__stat-value" style="font-size:22px">${boxList.length}</div></div>
          <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total weight</div><div class="ims__stat-value" style="font-size:22px">${totalWeight.toFixed(1)} kg</div></div>
          <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Vol. weight</div><div class="ims__stat-value" style="font-size:18px">${totalVol.toFixed(1)} kg</div></div>
        </div>
        <table class="ims__table" style="margin-top:6px">
          <thead><tr><th>Box</th><th>Label</th><th>L × W × H (cm)</th><th>Weight (kg)</th><th>Vol. wt (kg)</th></tr></thead>
          <tbody>${boxList.map(b => {
            const vol = ((b.length_cm||0)*(b.width_cm||0)*(b.height_cm||0))/5000;
            return `<tr>
              <td style="font-weight:600">Box ${b.box_number}</td>
              <td>${util().sanitize(b.label||'—')}</td>
              <td>${b.length_cm||'?'} × ${b.width_cm||'?'} × ${b.height_cm||'?'}</td>
              <td>${b.weight_kg||'—'}</td>
              <td style="color:var(--ims-text-muted)">${vol>0?vol.toFixed(1):'—'}</td>
            </tr>`;
          }).join('')}</tbody>
        </table>` :
        `<p style="font-size:12px;color:var(--ims-text-muted);margin-top:6px">No packaging data — add box dimensions when editing this SKU</p>`}
      <hr class="ims__divider">
      <strong style="font-size:13px">Current stock</strong>
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin:8px 0">
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">On hand</div><div class="ims__stat-value" style="font-size:22px">${onHand}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Reserved (orders)</div><div class="ims__stat-value" style="font-size:22px">${reserved}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Allocated (dropship)</div><div class="ims__stat-value" style="font-size:22px">${allocated}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Available</div><div class="ims__stat-value ims__stat-value--${(onHand-reserved-allocated)<0?'danger':''}" style="font-size:22px">${onHand-reserved-allocated}</div></div>
      </div>
      ${(stock||[]).length ? `
        <table class="ims__table" style="margin-top:6px">
          <thead><tr><th>Warehouse</th><th>Bin/shelf</th><th>Qty</th><th>Reserved</th><th>Allocated</th><th>Available</th></tr></thead>
          <tbody>${(stock||[]).map(s => `<tr><td>${util().sanitize(s.warehouses?.name||'—')}</td><td>${util().sanitize(s.bin_reference||'—')}</td><td>${s.quantity||0}</td><td>${s.reserved_qty||0}</td><td>${s.reserved_by_allocations||0}</td><td style="font-weight:600;color:${((s.quantity||0)-(s.reserved_qty||0)-(s.reserved_by_allocations||0))<0?'var(--ims-danger)':''}">${(s.quantity||0)-(s.reserved_qty||0)-(s.reserved_by_allocations||0)}</td></tr>`).join('')}</tbody>
        </table>` : '<p style="font-size:12px;color:var(--ims-text-muted);margin-top:6px">No stock yet — add stock via GRN, PO receiving or Stock Levels tab</p>'}
    `, `
      ${isAdmin() ? `<button class="ims__btn ims__btn--ghost" onclick="window.IMS_INVENTORY.showSKUForm('${p.id}')"><i class="ti ti-edit"></i> Edit SKU</button>` : ''}
      ${canSeeCost() ? `<button class="ims__btn ims__btn--ghost" onclick="window.IMS_INVENTORY.managePlatformPrices('${p.id}','${util().sanitize(p.name)}')"><i class="ti ti-apps"></i> Platform prices</button>` : ''}
      <button class="ims__btn ims__btn--secondary" onclick="window.IMS_INVENTORY.switchToAddStock('${p.id}','${util().sanitize(p.name)}')"><i class="ti ti-adjustments"></i> Add / adjust stock</button>
      <button class="ims__btn ims__btn--primary" onclick="window.SM.UI.closeModal()">Close</button>
    `, 'xl');
  }

  // ─── ADD / EDIT SKU FORM ─────────────────────────────────────────
  // _skuBoxes holds the in-memory box list during the form session
  let _skuBoxes = [];

  async function showSKUForm(existingId = null) {
    let p = null;
    let prices = {};
    _skuBoxes = [];

    const {data:catData}=await db().select('products',{select:'category',order:{col:'category'}});
    const existingCategories=[...new Set((catData||[]).map(p=>p.category).filter(Boolean))];

    if (existingId) {
      const { data } = await db().select('products', { eq: { id: existingId }, maybeSingle: true, noCompanyFilter: true });
      p = data;
      const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
      const { data: priceRows } = await client
        .from('product_prices')
        .select('price_type, price, platform_id')
        .eq('product_id', existingId)
        .is('platform_id', null);
      (priceRows || []).forEach(pp => { prices[pp.price_type] = pp.price; });

      // Load existing boxes
      const { data: boxRows } = await client
        .from('product_boxes')
        .select('*')
        .eq('product_id', existingId)
        .order('box_number');
      _skuBoxes = (boxRows || []).map(b => ({
        id: b.id,
        box_number: b.box_number,
        label: b.label || '',
        length_cm: b.length_cm || '',
        width_cm: b.width_cm || '',
        height_cm: b.height_cm || '',
        weight_kg: b.weight_kg || ''
      }));
    }

    const { data: whs } = await db().select('warehouses', { eq: { is_active: true } });
    const whOpts = (whs||[]).map(w => `<option value="${w.id}" ${p?.default_warehouse_id===w.id?'selected':''}>${util().sanitize(w.name)}</option>`).join('');

    ui().openModal(existingId ? `Edit SKU: ${p?.name}` : 'Add new SKU — Product catalogue', `
      <div class="ims__alert ims__alert--info" style="margin-bottom:12px">
        <i class="ti ti-info-circle"></i>
        <span>This adds the product to your <strong>catalogue only</strong>. Stock is managed separately via GRN, PO receiving, or the Stock Levels tab.</span>
      </div>
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Product name</label><input class="ims__input" type="text" id="ims-sku-name" value="${util().sanitize(p?.name||'')}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">SKU code</label><input class="ims__input" type="text" id="ims-sku-code" value="${util().sanitize(p?.sku||'')}" placeholder="e.g. CHR-001"></div>
        <div class="ims__form-group">
          <label class="ims__label">Category</label>
          <input class="ims__input" type="text" id="ims-sku-cat" value="${util().sanitize(p?.category||'')}"
            placeholder="e.g. Recliner Sofa" list="ims-sku-cat-list" autocomplete="off">
          <datalist id="ims-sku-cat-list">
            ${existingCategories.map(cat=>`<option value="${util().sanitize(cat)}">`).join('')}
          </datalist>
        </div>
        <div class="ims__form-group"><label class="ims__label">Barcode</label><input class="ims__input" type="text" id="ims-sku-barcode" value="${util().sanitize(p?.barcode||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Unit of measure</label><input class="ims__input" type="text" id="ims-sku-unit" value="${util().sanitize(p?.unit||'each')}" placeholder="each, pair, box, set..."></div>
        <div class="ims__form-group"><label class="ims__label">Reorder threshold</label><input class="ims__input" type="number" id="ims-sku-threshold" value="${p?.reorder_threshold!==undefined&&p?.reorder_threshold!==null?p.reorder_threshold:10}"><span class="ims__input-hint">Alert when stock falls below this</span></div>
        <div class="ims__form-group"><label class="ims__label">Reorder quantity</label><input class="ims__input" type="number" id="ims-sku-reorder-qty" value="${p?.reorder_quantity!==undefined&&p?.reorder_quantity!==null?p.reorder_quantity:50}"><span class="ims__input-hint">Suggested PO quantity</span></div>
        <div class="ims__form-group"><label class="ims__label">Default bin / shelf</label><input class="ims__input" type="text" id="ims-sku-bin" value="${util().sanitize(p?.default_bin||'')}" placeholder="e.g. A-51"></div>
        <div class="ims__form-group"><label class="ims__label">Default warehouse</label><select class="ims__select" id="ims-sku-warehouse"><option value="">None</option>${whOpts}</select></div>
      </div>

      <hr class="ims__divider">
      <strong style="font-size:13px">Pricing</strong>
      <div class="ims__form-grid" style="margin-top:10px">
        ${canSeeCost() ? `<div class="ims__form-group"><label class="ims__label">Cost price (£)</label><input class="ims__input" type="number" step="0.01" min="0" id="ims-sku-cost" value="${prices.cost??''}"><span class="ims__input-hint">Supplier invoice price — not shown to staff</span></div>` : ''}
        <div class="ims__form-group"><label class="ims__label ims__label--req">Wholesale price (£)</label><input class="ims__input" type="number" step="0.01" min="0" id="ims-sku-wholesale" value="${prices.wholesale??''}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">RRP / retail price (£)</label><input class="ims__input" type="number" step="0.01" min="0" id="ims-sku-rrp" value="${prices.rrp??''}"></div>
      </div>
      <div class="ims__form-group" style="margin-top:10px"><label class="ims__label">Notes</label><textarea class="ims__textarea" id="ims-sku-notes" rows="2">${util().sanitize(p?.notes||'')}</textarea></div>

      <hr class="ims__divider">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
        <div>
          <strong style="font-size:13px">Packaging / boxes</strong>
          <div style="font-size:11px;color:var(--ims-text-muted);margin-top:2px">One row per physical box. Used for courier labels, manifests and volumetric weight.</div>
        </div>
        <button class="ims__btn ims__btn--secondary ims__btn--sm" type="button" onclick="window.IMS_INVENTORY.addBoxRow()"><i class="ti ti-plus"></i> Add box</button>
      </div>
      <div id="ims-sku-boxes-wrap">
        ${_skuBoxes.length ? '' : `<div id="ims-sku-boxes-empty" style="font-size:12px;color:var(--ims-text-muted);padding:10px 0">No boxes defined yet — click <strong>Add box</strong> to start.</div>`}
        <table class="ims__table" id="ims-sku-boxes-table" style="${_skuBoxes.length ? '' : 'display:none'}">
          <thead>
            <tr>
              <th style="width:60px">Box #</th>
              <th>Label <span style="font-weight:400;font-size:10px">(e.g. Headboard, Frame)</span></th>
              <th>L (cm)</th>
              <th>W (cm)</th>
              <th>H (cm)</th>
              <th>Weight (kg)</th>
              <th>Vol. wt</th>
              <th></th>
            </tr>
          </thead>
          <tbody id="ims-sku-boxes-tbody">
            ${_skuBoxes.map((b, i) => _renderBoxRow(i, b)).join('')}
          </tbody>
        </table>
      </div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_INVENTORY.saveSKU('${existingId||''}')"><i class="ti ti-check"></i> ${existingId ? 'Save changes' : 'Add to catalogue'}</button>
    `, 'lg');
  }

  function _renderBoxRow(i, b = {}) {
    const vol = (parseFloat(b.length_cm)||0) * (parseFloat(b.width_cm)||0) * (parseFloat(b.height_cm)||0) / 5000;
    return `<tr id="ims-box-row-${i}">
      <td style="font-weight:600;text-align:center">${(b.box_number||i+1)}</td>
      <td><input class="ims__input ims__input--sm" type="text" id="ims-box-label-${i}" value="${util().sanitize(b.label||'')}" placeholder="e.g. Headboard"></td>
      <td><input class="ims__input ims__input--sm" type="number" min="0" step="0.1" id="ims-box-l-${i}" value="${b.length_cm||''}" placeholder="0" oninput="window.IMS_INVENTORY.updateVolWt(${i})" style="width:70px"></td>
      <td><input class="ims__input ims__input--sm" type="number" min="0" step="0.1" id="ims-box-w-${i}" value="${b.width_cm||''}" placeholder="0" oninput="window.IMS_INVENTORY.updateVolWt(${i})" style="width:70px"></td>
      <td><input class="ims__input ims__input--sm" type="number" min="0" step="0.1" id="ims-box-h-${i}" value="${b.height_cm||''}" placeholder="0" oninput="window.IMS_INVENTORY.updateVolWt(${i})" style="width:70px"></td>
      <td><input class="ims__input ims__input--sm" type="number" min="0" step="0.01" id="ims-box-wt-${i}" value="${b.weight_kg||''}" placeholder="0" style="width:80px"></td>
      <td id="ims-box-vol-${i}" style="font-size:12px;color:var(--ims-text-muted);white-space:nowrap">${vol > 0 ? vol.toFixed(2)+' kg' : '—'}</td>
      <td><button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" type="button" onclick="window.IMS_INVENTORY.removeBoxRow(${i})" title="Remove box"><i class="ti ti-trash"></i></button></td>
    </tr>`;
  }

  function addBoxRow() {
    _skuBoxes.push({ box_number: _skuBoxes.length + 1, label: '', length_cm: '', width_cm: '', height_cm: '', weight_kg: '' });
    const i = _skuBoxes.length - 1;
    const tbody = document.getElementById('ims-sku-boxes-tbody');
    const table = document.getElementById('ims-sku-boxes-table');
    const empty = document.getElementById('ims-sku-boxes-empty');
    if (empty) empty.style.display = 'none';
    if (table) table.style.display = '';
    if (tbody) tbody.insertAdjacentHTML('beforeend', _renderBoxRow(i, _skuBoxes[i]));
  }

  function removeBoxRow(i) {
    _skuBoxes.splice(i, 1);
    // Re-render the full table to keep indices in sync
    const tbody = document.getElementById('ims-sku-boxes-tbody');
    const table = document.getElementById('ims-sku-boxes-table');
    const empty = document.getElementById('ims-sku-boxes-empty');
    if (!_skuBoxes.length) {
      if (table) table.style.display = 'none';
      if (empty) empty.style.display = '';
      if (tbody) tbody.innerHTML = '';
      return;
    }
    if (tbody) tbody.innerHTML = _skuBoxes.map((b, idx) => _renderBoxRow(idx, b)).join('');
  }

  function updateVolWt(i) {
    const l = parseFloat(document.getElementById(`ims-box-l-${i}`)?.value) || 0;
    const w = parseFloat(document.getElementById(`ims-box-w-${i}`)?.value) || 0;
    const h = parseFloat(document.getElementById(`ims-box-h-${i}`)?.value) || 0;
    const vol = (l * w * h) / 5000;
    const el = document.getElementById(`ims-box-vol-${i}`);
    if (el) el.textContent = vol > 0 ? vol.toFixed(2) + ' kg' : '—';
  }

  function _readBoxRows() {
    return _skuBoxes.map((_, i) => ({
      box_number: i + 1,
      label: document.getElementById(`ims-box-label-${i}`)?.value?.trim() || null,
      length_cm: parseFloat(document.getElementById(`ims-box-l-${i}`)?.value) || null,
      width_cm:  parseFloat(document.getElementById(`ims-box-w-${i}`)?.value) || null,
      height_cm: parseFloat(document.getElementById(`ims-box-h-${i}`)?.value) || null,
      weight_kg: parseFloat(document.getElementById(`ims-box-wt-${i}`)?.value) || null,
    }));
  }

  async function saveSKU(existingId) {
    const g = id => document.getElementById(id)?.value?.trim() || '';
    const name = g('ims-sku-name'), sku = g('ims-sku-code');
    if (!name) { ui().toast('Product name is required', 'error'); return; }
    if (!sku)  { ui().toast('SKU code is required', 'error'); return; }

    const data = {
      name, sku,
      category:             g('ims-sku-cat') || null,
      barcode:              g('ims-sku-barcode') || null,
      unit:                 g('ims-sku-unit') || 'each',
      reorder_threshold:    g('ims-sku-threshold')!=='' ? parseInt(g('ims-sku-threshold')) : 10,
      reorder_quantity:     g('ims-sku-reorder-qty')!=='' ? parseInt(g('ims-sku-reorder-qty')) : 50,
      default_bin:          g('ims-sku-bin') || null,
      default_warehouse_id: g('ims-sku-warehouse') || null,
      notes:                g('ims-sku-notes') || null,
      updated_at:           new Date().toISOString()
    };

    let productId;
    if (existingId) {
      const { error } = await db().update('products', existingId, data);
      if (error) { ui().toast('Failed: ' + error.message, 'error'); return; }
      productId = existingId;
    } else {
      const { data: created, error } = await db().insert('products', data);
      if (error) { ui().toast('Failed: ' + error.message, 'error'); return; }
      productId = created.id;
    }

    // Save prices
    const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
    const priceFields = [
      canSeeCost() ? { type: 'cost', id: 'ims-sku-cost' } : null,
      { type: 'wholesale', id: 'ims-sku-wholesale' },
      { type: 'rrp',       id: 'ims-sku-rrp'       }
    ].filter(Boolean);

    await Promise.all(priceFields.map(async ({ type, id }) => {
      const fieldEl = document.getElementById(id);
      if (!fieldEl) return;
      const rawVal = fieldEl.value.trim();
      await client.from('product_prices')
        .delete()
        .eq('product_id', productId)
        .eq('price_type', type)
        .is('platform_id', null);
      if (rawVal === '') return;
      const val = parseFloat(rawVal);
      if (isNaN(val)) return;
      await client.from('product_prices')
        .insert({ product_id: productId, price_type: type, platform_id: null, price: val });
    }));

    // Save boxes — delete all existing, re-insert from form
    await client.from('product_boxes').delete().eq('product_id', productId);
    const boxRows = _readBoxRows();
    if (boxRows.length) {
      await client.from('product_boxes').insert(
        boxRows.map(b => ({ ...b, product_id: productId }))
      );
    }

    ui().closeModal();
    ui().toast(`${existingId ? 'SKU updated' : `"${name}" added to catalogue`}`, 'success');
    loadCatalogueData();
  }

  // ═══════════════════════════════════════════════════════════════
  // TAB 2 — STOCK LEVELS
  // ═══════════════════════════════════════════════════════════════
  async function loadStock() {
    const content = document.getElementById('ims-inv-content');
    if (!content) return;

    const actions = document.getElementById('ims-inv-actions');
    if (actions) {
      actions.innerHTML = `
        <button class="ims__btn ims__btn--secondary" id="ims-stock-import-btn"><i class="ti ti-upload"></i> Bulk import stock</button>
        <button class="ims__btn ims__btn--primary" id="ims-stock-add-btn"><i class="ti ti-plus"></i> Add stock</button>`;
      document.getElementById('ims-stock-add-btn')?.addEventListener('click', () => showAddStockForm());
      document.getElementById('ims-stock-import-btn')?.addEventListener('click', () => showBulkStockImport());
    }

    content.innerHTML = `
      <div class="ims__alert ims__alert--info" style="margin-bottom:14px">
        <i class="ti ti-info-circle"></i>
        <span><strong>Stock Levels</strong> — Live inventory quantities per product and warehouse. Stock is added automatically via GRN and PO receiving. Use <strong>Add stock</strong> for opening stock or manual corrections only.</span>
      </div>
      <div class="ims__filters">
        <div class="ims__search-wrap"><i class="ti ti-search"></i><input class="ims__input" type="text" id="ims-stk-search" placeholder="Product name or SKU..."></div>
        <select class="ims__select" id="ims-stk-warehouse"><option value="">All warehouses</option></select>
        <select class="ims__select" id="ims-stk-filter">
          <option value="">All stock</option>
          <option value="low">Low stock</option>
          <option value="out">Out of stock</option>
          <option value="ok">In stock</option>
        </select>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr>
              <th>SKU</th><th>Product</th><th>Warehouse</th><th>Bin / shelf</th>
              <th>On hand</th><th>Reserved</th><th>Available</th><th>Status</th><th></th>
            </tr></thead>
            <tbody id="ims-stk-tbody"><tr><td colspan="9" class="ims__table-empty"><i class="ti ti-loader-2 ims__spin"></i></td></tr></tbody>
          </table>
        </div>
      </div>`;

    const { data: whs } = await db().select('warehouses', { eq: { is_active: true } });
    const whSel = document.getElementById('ims-stk-warehouse');
    if (whSel) {
      whSel.innerHTML = '<option value="">All warehouses</option>';
      (whs||[]).forEach(w => { const o = document.createElement('option'); o.value = w.id; o.textContent = w.name; whSel.appendChild(o); });
    }

    document.getElementById('ims-stk-search')?.addEventListener('input', util().debounce(loadStockData, 350));
    document.getElementById('ims-stk-warehouse')?.addEventListener('change', loadStockData);
    document.getElementById('ims-stk-filter')?.addEventListener('change', loadStockData);

    await loadStockData();
  }

  async function loadStockData() {
    const tbody = document.getElementById('ims-stk-tbody');
    if (!tbody) return;

    const search     = document.getElementById('ims-stk-search')?.value?.trim().toLowerCase() || '';
    const warehouseF = document.getElementById('ims-stk-warehouse')?.value || '';
    const stockF     = document.getElementById('ims-stk-filter')?.value || '';

    const opts = {
      select: 'quantity,reserved_qty,reserved_by_allocations,bin_reference,warehouse_id,product_id,warehouses(name),products(id,name,sku,reorder_threshold)',
      noCompanyFilter: true,
      order: { col: 'quantity' }
    };
    if (warehouseF) opts.eq = { warehouse_id: warehouseF };

    const { data: stock } = await db().select('stock_levels', opts);
    const { data: companyProducts } = await db().select('products', { select: 'id' });
    const myProductIds = new Set((companyProducts||[]).map(p => p.id));
    let items = (stock||[]).filter(s => s.products && myProductIds.has(s.product_id));

    if (search) items = items.filter(s => s.products?.name?.toLowerCase().includes(search) || s.products?.sku?.toLowerCase().includes(search));
    if (stockF === 'low')  items = items.filter(s => s.quantity > 0 && s.quantity <= (s.products?.reorder_threshold||10));
    if (stockF === 'out')  items = items.filter(s => s.quantity <= 0);
    if (stockF === 'ok')   items = items.filter(s => s.quantity > (s.products?.reorder_threshold||10));

    if (!items.length) {
      tbody.innerHTML = `<tr><td colspan="9" class="ims__table-empty">${stockF||search ? 'No products match your filter' : 'No stock records yet — stock is added via GRN, PO receiving, or the Add stock button'}</td></tr>`;
      return;
    }

    tbody.innerHTML = items.map(s => {
      const avail = (s.quantity||0) - (s.reserved_qty||0) - (s.reserved_by_allocations||0);
      const threshold = s.products?.reorder_threshold || 10;
      const st = s.quantity <= 0 ? 'danger' : s.quantity <= threshold ? 'warning' : 'success';
      const stLabel = s.quantity <= 0 ? 'Out of stock' : s.quantity <= threshold ? 'Low stock' : 'OK';
      return `<tr>
        <td>${util().sanitize(s.products?.sku||'—')}</td>
        <td><span class="ims__link" onclick="window.IMS_INVENTORY.openSKU('${s.product_id}')">${util().sanitize(s.products?.name||'—')}</span></td>
        <td>${util().sanitize(s.warehouses?.name||'—')}</td>
        <td>${util().sanitize(s.bin_reference||'—')}</td>
        <td style="font-weight:600">${s.quantity||0}</td>
        <td>${s.reserved_qty||0}${s.reserved_by_allocations?` <span style="color:var(--ims-text-muted);font-size:10px">(+${s.reserved_by_allocations} alloc.)</span>`:''}</td>
        <td style="font-weight:600;color:${avail<0?'var(--ims-danger)':''}">${avail}</td>
        <td><span class="ims__pill ims__pill--${st}">${stLabel}</span></td>
        <td>
          <div class="ims__btn-group">
            <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_INVENTORY.showAdjustStock('${s.product_id}','${util().sanitize(s.products?.name||'')}','${s.warehouse_id}')" title="Adjust stock"><i class="ti ti-adjustments"></i></button>
          </div>
        </td>
      </tr>`;
    }).join('');
  }

  // ─── ADD STOCK FORM ──────────────────────────────────────────────
  async function showAddStockForm(preselectedProductId = null, preselectedName = '') {
    const { data: products } = await db().select('products', { eq: { is_active: true }, order: { col: 'name' }, select: 'id,name,sku' });
    const { data: whs } = await db().select('warehouses', { eq: { is_active: true } });

    const prodOpts = (products||[]).map(p =>
      `<option value="${p.id}" ${p.id===preselectedProductId?'selected':''}>${util().sanitize(p.name)} (${p.sku})</option>`
    ).join('');
    const whOpts = (whs||[]).map(w => `<option value="${w.id}">${util().sanitize(w.name)}</option>`).join('');

    if (!products?.length) {
      ui().toast('Add products to the catalogue first before adding stock', 'warning', 5000);
      return;
    }

    ui().openModal('Add stock — select from catalogue', `
      <div class="ims__alert ims__alert--info" style="margin-bottom:12px">
        <i class="ti ti-info-circle"></i>
        <span>Use this for <strong>opening stock entry</strong> or <strong>manual corrections</strong> only. Stock should normally arrive through GRN or PO receiving.</span>
      </div>
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full">
          <label class="ims__label ims__label--req">Product</label>
          <select class="ims__select" id="ims-as-product" onchange="window.IMS_INVENTORY.onProductSelected()">
            <option value="">Select product from catalogue...</option>${prodOpts}
          </select>
        </div>
        <div class="ims__form-group" id="ims-as-bin-group" style="display:none">
          <label class="ims__label">Current default bin</label>
          <input class="ims__input" type="text" id="ims-as-default-bin" readonly style="background:var(--ims-surface2)">
        </div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Warehouse</label>
          <select class="ims__select" id="ims-as-warehouse"><option value="">Select warehouse</option>${whOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Quantity to add</label>
          <input class="ims__input" type="number" min="1" id="ims-as-qty" placeholder="Enter quantity"></div>
        <div class="ims__form-group"><label class="ims__label">Bin / shelf reference</label>
          <input class="ims__input" type="text" id="ims-as-bin" placeholder="e.g. A-51 (leave blank to use default)"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Reason</label>
          <select class="ims__select" id="ims-as-reason">
            <option value="Opening stock">Opening stock entry</option>
            <option value="Stock correction">Stock correction (count discrepancy)</option>
            <option value="Sample stock">Sample / display stock</option>
            <option value="Returned to stock">Customer return restocked</option>
            <option value="Other">Other</option>
          </select></div>
        <div class="ims__form-group"><label class="ims__label">Reference</label>
          <input class="ims__input" type="text" id="ims-as-ref" placeholder="e.g. opening stock, correction ref..."></div>
      </div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_INVENTORY.saveAddStock()"><i class="ti ti-check"></i> Add to stock</button>
    `, 'sm');
  }

  async function onProductSelected() {
    const productId = document.getElementById('ims-as-product')?.value;
    if (!productId) return;
    const { data: p } = await db().select('products', { eq: { id: productId }, maybeSingle: true, noCompanyFilter: true });
    if (!p) return;
    const binGroup = document.getElementById('ims-as-bin-group');
    const binEl    = document.getElementById('ims-as-default-bin');
    if (binEl && p.default_bin) {
      binEl.value = p.default_bin;
      if (binGroup) binGroup.style.display = '';
      const binInput = document.getElementById('ims-as-bin');
      if (binInput && !binInput.value) binInput.value = p.default_bin;
    } else {
      if (binGroup) binGroup.style.display = 'none';
    }
  }

  async function saveAddStock() {
    const productId   = document.getElementById('ims-as-product')?.value;
    const warehouseId = document.getElementById('ims-as-warehouse')?.value;
    const qty         = parseInt(document.getElementById('ims-as-qty')?.value) || 0;
    const bin         = document.getElementById('ims-as-bin')?.value?.trim();
    const reason      = document.getElementById('ims-as-reason')?.value;
    const ref         = document.getElementById('ims-as-ref')?.value?.trim();

    if (!productId)   { ui().toast('Please select a product', 'error'); return; }
    if (!warehouseId) { ui().toast('Please select a warehouse', 'error'); return; }
    if (qty <= 0)     { ui().toast('Please enter a quantity greater than 0', 'error'); return; }

    const { data: existing } = await db().select('stock_levels', {
      eq: { product_id: productId, warehouse_id: warehouseId },
      maybeSingle: true, noCompanyFilter: true
    });

    if (existing) {
      await db().update('stock_levels', existing.id, {
        quantity:      (existing.quantity||0) + qty,
        bin_reference: bin || existing.bin_reference,
        last_updated:  new Date().toISOString()
      });
    } else {
      await db().insert('stock_levels', {
        product_id:    productId,
        warehouse_id:  warehouseId,
        quantity:      qty,
        reserved_qty:  0,
        bin_reference: bin || null
      });
    }

    await db().insert('stock_movements', {
      product_id:    productId,
      warehouse_id:  warehouseId,
      movement_type: 'stock_in',
      quantity:      qty,
      reference:     ref || null,
      reason,
      user_id:       window.SM.AUTH.user?.id
    });

    ui().closeModal();
    ui().toast(`${qty} units added to stock`, 'success');
    loadStockData();
  }

  function switchToAddStock(productId, productName) {
    ui().closeModal();
    const tabs = document.getElementById('ims-inv-tabs');
    tabs?.querySelectorAll('.ims__tab').forEach(t => t.classList.remove('ims__tab--active'));
    tabs?.querySelector('[data-tab="stock"]')?.classList.add('ims__tab--active');
    _activeTab = 'stock';
    loadStock().then(() => {
      setTimeout(() => showAddStockForm(productId, productName), 300);
    });
  }

  // ─── STOCK ADJUSTMENT ────────────────────────────────────────────
  async function showAdjustStock(productId, productName, warehouseId){
    const {data:sl}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:warehouseId},maybeSingle:true,noCompanyFilter:true});
    const current=sl?.quantity||0;
    const currentBin=sl?.bin_reference||'—';

    ui().openModal(`Adjust stock: ${productName}`,`
      <div style="margin-bottom:14px;padding:12px;background:var(--ims-surface2);border-radius:var(--ims-radius)">
        <span class="ims__label">Current stock</span>
        <div style="font-size:28px;font-weight:700">${current} units</div>
        <div style="font-size:12px;color:var(--ims-text-muted);margin-top:2px">Current location: <strong>${util().sanitize(currentBin)}</strong></div>
      </div>
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full">
          <label class="ims__label ims__label--req">Adjustment type</label>
          <select class="ims__select" id="ims-adj-type" onchange="window.IMS_INVENTORY.onAdjTypeChange()">
            <option value="stock_in">Add stock (+)</option>
            <option value="stock_out">Remove stock (−)</option>
            <option value="adjustment">Set exact quantity</option>
            <option value="move">Move to new location</option>
          </select>
        </div>
      </div>

      <!-- Standard adjustment fields -->
      <div id="ims-adj-standard" class="ims__form-grid" style="margin-top:8px">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Quantity</label>
          <input class="ims__input" type="number" min="0" id="ims-adj-qty" placeholder="Enter quantity"></div>
        <div class="ims__form-group"><label class="ims__label">New bin reference</label>
          <input class="ims__input" type="text" id="ims-adj-bin" value="${util().sanitize(sl?.bin_reference||'')}" placeholder="Leave blank to keep current"></div>
        <div class="ims__form-group"><label class="ims__label">Reference</label>
          <input class="ims__input" type="text" id="ims-adj-ref" placeholder="e.g. cycle count, correction..."></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Reason</label>
          <textarea class="ims__textarea" id="ims-adj-reason" rows="2" placeholder="Explain reason for this adjustment"></textarea></div>
      </div>

      <!-- Move to new location fields -->
      <div id="ims-adj-move" class="ims__form-grid" style="margin-top:8px;display:none">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Quantity to move</label>
          <input class="ims__input" type="number" min="1" max="${current}" id="ims-adj-move-qty" placeholder="How many units to move"></div>
        <div class="ims__form-group"><label class="ims__label">From location</label>
          <input class="ims__input" type="text" value="${util().sanitize(currentBin)}" readonly style="background:var(--ims-surface2)"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">To location (new bin)</label>
          <input class="ims__input" type="text" id="ims-adj-move-bin" placeholder="e.g. B-12"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Reason</label>
          <textarea class="ims__textarea" id="ims-adj-move-reason" rows="2" placeholder="e.g. Reorganised storage, overflow to new bay"></textarea></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_INVENTORY.saveAdjustment('${productId}','${warehouseId}',${current})"><i class="ti ti-check"></i> Save</button>
    `,'sm');
  }

  function onAdjTypeChange(){
    const type=document.getElementById('ims-adj-type')?.value;
    const standard=document.getElementById('ims-adj-standard');
    const move=document.getElementById('ims-adj-move');
    if(standard) standard.style.display=type==='move'?'none':'grid';
    if(move)     move.style.display=type==='move'?'grid':'none';
  }

  async function saveAdjustment(productId, warehouseId, current){
    const type=document.getElementById('ims-adj-type')?.value;

    // ── MOVE TO NEW LOCATION ────────────────────────────────────
    if(type==='move'){
      const moveQty=parseInt(document.getElementById('ims-adj-move-qty')?.value)||0;
      const moveBin=document.getElementById('ims-adj-move-bin')?.value?.trim();
      const reason=document.getElementById('ims-adj-move-reason')?.value?.trim();
      if(!moveQty||moveQty<=0){ui().toast('Enter a quantity to move','error');return;}
      if(moveQty>current){ui().toast(`Cannot move more than current stock (${current})`,'error');return;}
      if(!moveBin){ui().toast('Enter the destination bin location','error');return;}
      if(!reason){ui().toast('Please enter a reason','error');return;}

      // Reduce from current row
      const {data:existing}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:warehouseId},maybeSingle:true,noCompanyFilter:true});
      if(existing){
        await db().update('stock_levels',existing.id,{quantity:current-moveQty,last_updated:new Date().toISOString()});
      }

      // Add to destination bin — check if a row already exists for that bin
      const {data:destRow}=await db().select('stock_levels',{
        select:'id,quantity',
        eq:{product_id:productId,warehouse_id:warehouseId,bin_reference:moveBin},
        maybeSingle:true,noCompanyFilter:true
      });

      if(destRow){
        await db().update('stock_levels',destRow.id,{quantity:(destRow.quantity||0)+moveQty,last_updated:new Date().toISOString()});
      } else {
        await db().insert('stock_levels',{product_id:productId,warehouse_id:warehouseId,quantity:moveQty,reserved_qty:0,bin_reference:moveBin,company_id:window.SM.AUTH.company?.id});
      }

      // Log two movements: out from old bin, in to new bin
      await db().insert('stock_movements',{product_id:productId,warehouse_id:warehouseId,movement_type:'stock_out',quantity:-moveQty,reason:`Location move: to ${moveBin} — ${reason}`,user_id:window.SM.AUTH.user?.id});
      await db().insert('stock_movements',{product_id:productId,warehouse_id:warehouseId,movement_type:'stock_in',quantity:moveQty,reason:`Location move: from existing bin — ${reason}`,reference:moveBin,user_id:window.SM.AUTH.user?.id});

      ui().closeModal();
      ui().toast(`${moveQty} units moved to ${moveBin}`,'success');
      loadStockData();
      return;
    }

    // ── STANDARD ADJUSTMENT ──────────────────────────────────────
    const qty=parseInt(document.getElementById('ims-adj-qty')?.value);
    const bin=document.getElementById('ims-adj-bin')?.value?.trim();
    const ref=document.getElementById('ims-adj-ref')?.value?.trim();
    const reason=document.getElementById('ims-adj-reason')?.value?.trim();
    if(isNaN(qty)||qty<0){ui().toast('Please enter a valid quantity','error');return;}
    if(!reason){ui().toast('Please enter a reason','error');return;}

    let newQty,movement;
    if(type==='adjustment'){newQty=qty;movement=qty-current;}
    else if(type==='stock_in'){newQty=current+qty;movement=qty;}
    else{newQty=Math.max(0,current-qty);movement=-(Math.min(qty,current));}

    const {data:existing}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:warehouseId},maybeSingle:true,noCompanyFilter:true});
    if(existing){
      await db().update('stock_levels',existing.id,{quantity:newQty,bin_reference:bin||existing.bin_reference,last_updated:new Date().toISOString()});
    } else {
      await db().insert('stock_levels',{product_id:productId,warehouse_id:warehouseId,quantity:newQty,reserved_qty:0,bin_reference:bin||null});
    }

    await db().insert('stock_movements',{product_id:productId,warehouse_id:warehouseId,movement_type:type,quantity:movement,reference:ref||null,reason,user_id:window.SM.AUTH.user?.id});

    ui().closeModal();
    ui().toast(`Stock adjusted — new quantity: ${newQty}`,'success');
    loadStockData();
  }

  // ─── BULK OPENING STOCK IMPORT ───────────────────────────────────
  function showBulkStockImport() {
    ui().openModal('Bulk import opening stock', `
      <div class="ims__alert ims__alert--info" style="margin-bottom:12px">
        <i class="ti ti-info-circle"></i>
        <span>Use this to upload opening stock quantities in bulk. Download the template, fill in quantities for each product, and upload. <strong>This adds to existing stock — it does not overwrite.</strong></span>
      </div>
      <div class="ims__btn-group" style="margin-bottom:14px">
        <button class="ims__btn ims__btn--secondary" onclick="window.IMS_INVENTORY.downloadStockTemplate()"><i class="ti ti-download"></i> Download stock template</button>
      </div>
      <div class="ims__form-group">
        <label class="ims__label ims__label--req">Select warehouse</label>
        <select class="ims__select" id="ims-bulk-wh-sel"><option value="">Loading warehouses...</option></select>
      </div>
      <div class="ims__form-group">
        <label class="ims__label">Select CSV file</label>
        <input type="file" accept=".csv" id="ims-bulk-stock-file" class="ims__input"
          onchange="window.IMS_INVENTORY.previewBulkStock(this)">
      </div>
      <div id="ims-bulk-stock-preview"></div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" id="ims-bulk-stock-commit" style="display:none"
        onclick="window.IMS_INVENTORY.commitBulkStock()"><i class="ti ti-check"></i> Import stock</button>
    `, 'lg');

    db().select('warehouses', { eq: { is_active: true } }).then(({ data: whs }) => {
      const sel = document.getElementById('ims-bulk-wh-sel');
      if (!sel) return;
      sel.innerHTML = '<option value="">Select warehouse...</option>' +
        (whs||[]).map(w => `<option value="${w.id}">${util().sanitize(w.name)}</option>`).join('');
    });
  }

  async function downloadStockTemplate() {
    const { data: products } = await db().select('products', { select: 'sku,name,category,default_bin', order: { col: 'name' } });
    const headers = ['SKU', 'Product Name', 'Category', 'Default Bin', 'Quantity', 'Bin Reference (leave blank to use default)'];
    const rows = (products||[]).map(p => [p.sku, p.name, p.category||'', p.default_bin||'', '0', '']);
    if (!rows.length) { ui().toast('Add products to the catalogue first', 'warning'); return; }
    util().exportCSV(headers, rows, 'opening_stock_template');
    ui().toast(`Template downloaded with ${rows.length} products`, 'success');
  }

  let _bulkStockRows = [];

  async function previewBulkStock(input) {
    const file = input.files?.[0];
    if (!file) return;
    const text = await file.text();
    const { headers, rows } = util().parseCSV(text);
    const preview = document.getElementById('ims-bulk-stock-preview');
    const commitBtn = document.getElementById('ims-bulk-stock-commit');

    const { data: products } = await db().select('products', { select: 'id,sku,name' });
    const skuMap = {};
    (products||[]).forEach(p => { skuMap[p.sku.toUpperCase()] = p; });

    _bulkStockRows = rows.map(row => {
      const get = col => { const i = headers.indexOf(col); return i >= 0 ? row[i]||'' : ''; };
      const sku = get('SKU').toUpperCase();
      const qty = parseInt(get('Quantity')) || 0;
      const bin = get('Bin Reference (leave blank to use default)') || get('Default Bin') || '';
      const product = skuMap[sku];
      return {
        sku,
        name: get('Product Name') || product?.name || '—',
        productId: product?.id || null,
        qty,
        bin: bin || product?.default_bin || '',
        valid: !!product && qty > 0
      };
    }).filter(r => r.sku);

    const valid   = _bulkStockRows.filter(r => r.valid).length;
    const skipped = _bulkStockRows.filter(r => !r.productId).length;
    const zeroQty = _bulkStockRows.filter(r => r.productId && r.qty === 0).length;

    if (preview) preview.innerHTML = `
      <div class="ims__alert ims__alert--${valid>0?'success':'warning'}" style="margin-top:12px">
        <i class="ti ti-${valid>0?'check':'alert-triangle'}"></i>
        <span><strong>${valid} products</strong> will have stock added &nbsp;|&nbsp; ${zeroQty} skipped (zero qty) &nbsp;|&nbsp; ${skipped} SKUs not found</span>
      </div>
      <div class="ims__table-wrap" style="max-height:220px;overflow-y:auto;margin-top:8px">
        <table class="ims__table">
          <thead><tr><th>SKU</th><th>Product</th><th>Qty</th><th>Bin</th><th>Status</th></tr></thead>
          <tbody>${_bulkStockRows.slice(0,15).map(r=>`<tr>
            <td>${util().sanitize(r.sku)}</td><td>${util().sanitize(r.name)}</td>
            <td style="font-weight:600">${r.qty}</td><td>${util().sanitize(r.bin||'—')}</td>
            <td>${r.valid?'<span class="ims__pill ims__pill--success">✓ Will import</span>':r.productId?'<span class="ims__pill ims__pill--neutral">Zero qty</span>':'<span class="ims__pill ims__pill--danger">SKU not found</span>'}</td>
          </tr>`).join('')}
          ${_bulkStockRows.length>15?`<tr><td colspan="5" class="ims__table-empty">...and ${_bulkStockRows.length-15} more rows</td></tr>`:''}
          </tbody>
        </table>
      </div>`;

    if (commitBtn) commitBtn.style.display = valid > 0 ? 'inline-flex' : 'none';
  }

  async function commitBulkStock() {
    const warehouseId = document.getElementById('ims-bulk-wh-sel')?.value;
    if (!warehouseId) { ui().toast('Please select a warehouse', 'error'); return; }
    const valid = _bulkStockRows.filter(r => r.valid);
    if (!valid.length) { ui().toast('No valid rows to import', 'error'); return; }
    const commitBtn = document.getElementById('ims-bulk-stock-commit');
    if (commitBtn) { commitBtn.disabled = true; commitBtn.innerHTML = '<i class="ti ti-loader-2 ims__spin"></i> Importing...'; }
    const preview = document.getElementById('ims-bulk-stock-preview');
    const total = valid.length;
    if (preview) preview.innerHTML += `<div style="margin-top:12px"><div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:4px"><span id="ims-stk-progress-label">Starting...</span><span id="ims-stk-progress-pct">0%</span></div><div style="background:var(--ims-border);border-radius:999px;height:8px;overflow:hidden"><div id="ims-stk-progress-bar" style="height:100%;background:var(--ims-primary);width:0%;transition:width 0.2s;border-radius:999px"></div></div></div>`;
    let imported = 0;
    for (let i = 0; i < valid.length; i++) {
      const row = valid[i];
      const pct = Math.round(((i+1)/total)*100);
      document.getElementById('ims-stk-progress-label')?.setAttribute('textContent', `Importing ${i+1} of ${total}: ${row.name}`);
      const pctEl = document.getElementById('ims-stk-progress-pct'); if (pctEl) pctEl.textContent = pct+'%';
      const bar = document.getElementById('ims-stk-progress-bar'); if (bar) bar.style.width = pct+'%';
      const { data: existing } = await db().select('stock_levels', { eq: { product_id: row.productId, warehouse_id: warehouseId }, maybeSingle: true, noCompanyFilter: true });
      if (existing) {
        await db().update('stock_levels', existing.id, { quantity: (existing.quantity||0)+row.qty, bin_reference: row.bin||existing.bin_reference, last_updated: new Date().toISOString() });
      } else {
        await db().insert('stock_levels', { product_id: row.productId, warehouse_id: warehouseId, quantity: row.qty, reserved_qty: 0, bin_reference: row.bin||null });
      }
      await db().insert('stock_movements', { product_id: row.productId, warehouse_id: warehouseId, movement_type: 'stock_in', quantity: row.qty, reference: 'Bulk opening stock import', reason: 'Opening stock entry', user_id: window.SM.AUTH.user?.id });
      imported++;
    }
    ui().closeModal();
    ui().toast(`Opening stock imported — ${imported} products updated`, 'success', 5000);
    _bulkStockRows = [];
    loadStockData();
  }

  // ─── PLATFORM PRICES ─────────────────────────────────────────────
  async function managePlatformPrices(productId, productName) {
    const companyId = window.SM.AUTH.company?.id;
    const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
    const [{ data: sys }, { data: custom }] = await Promise.all([
      client.from('platforms').select('id,name,order_type').is('company_id', null).eq('is_active', true).order('sort_order'),
      client.from('platforms').select('id,name,order_type').eq('company_id', companyId).eq('is_active', true).order('name')
    ]);
    const platforms = [...(sys||[]), ...(custom||[])];
    const { data: existing } = await client.from('product_prices').select('*').eq('product_id', productId).eq('price_type', 'platform');
    const priceMap = {};
    (existing||[]).forEach(p => { priceMap[p.platform_id] = p.price; });

    ui().openModal(`Platform prices: ${productName}`, `
      <p style="font-size:12px;color:var(--ims-text-muted);margin-bottom:14px">Set a specific price for each platform. Leave blank to use the default wholesale or RRP.</p>
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Platform</th><th>Type</th><th>Price (£)</th><th>Note</th></tr></thead>
          <tbody>${platforms.map(p=>`<tr>
            <td><strong>${util().sanitize(p.name)}</strong></td>
            <td><span class="ims__pill ims__pill--${p.order_type==='wholesale'?'info':'neutral'}">${p.order_type}</span></td>
            <td><input class="ims__input" type="number" step="0.01" min="0" id="ims-pp-${p.id}" value="${priceMap[p.id]!==undefined?priceMap[p.id]:''}" placeholder="Use default" style="width:120px"></td>
            <td style="font-size:11px;color:var(--ims-text-muted)">${p.order_type==='wholesale'||p.name==='Wayfair'||p.name==='Temu'?'Excl. VAT':''}</td>
          </tr>`).join('')}
          </tbody>
        </table>
      </div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_INVENTORY.savePlatformPrices('${productId}',${JSON.stringify(platforms.map(p=>p.id)).replace(/"/g,"'")})"><i class="ti ti-check"></i> Save platform prices</button>
    `, 'lg');
  }

  async function savePlatformPrices(productId, platformIds) {
    const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
    let saved = 0;
    for (const pid of platformIds) {
      const input = document.getElementById(`ims-pp-${pid}`);
      if (!input) continue;
      const val = input.value.trim();
      if (val === '') {
        await client.from('product_prices').delete().eq('product_id', productId).eq('price_type', 'platform').eq('platform_id', pid);
      } else {
        const price = parseFloat(val);
        if (isNaN(price)) continue;
        await client.from('product_prices').upsert(
          { product_id: productId, price_type: 'platform', platform_id: pid, price },
          { onConflict: 'product_id,price_type,platform_id' }
        );
        saved++;
      }
    }
    ui().closeModal();
    ui().toast(`Platform prices saved (${saved} set)`, 'success');
    loadCatalogueData();
  }

  // ─── DELETE SKU ──────────────────────────────────────────────────
  async function deleteSKU(productId, productName) {
    const [{ data: stock }, { data: orderItems }] = await Promise.all([
      db().select('stock_levels', { eq: { product_id: productId }, noCompanyFilter: true }),
      db().select('order_items', { eq: { product_id: productId }, noCompanyFilter: true, limit: 1 })
    ]);
    const hasStock  = (stock||[]).some(s => (s.quantity||0) > 0);
    const hasOrders = (orderItems||[]).length > 0;
    const stockWarn = hasStock ? " This product has stock in your warehouse. Deleting it will remove stock records." : "";
    const orderWarn = hasOrders ? " This product appears on past orders. Order history is kept but the product link removed." : "";
    ui().confirm(`Delete "${productName}" from the catalogue?${stockWarn}${orderWarn} This cannot be undone.`, async () => {
      const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
      await client.from('product_prices').delete().eq('product_id', productId);
      await client.from('product_boxes').delete().eq('product_id', productId);
      await client.from('stock_levels').delete().eq('product_id', productId);
      await client.from('stock_movements').delete().eq('product_id', productId);
      const { error } = await db().remove('products', productId);
      if (error) { ui().toast('Failed: ' + error.message, 'error'); return; }
      ui().toast(`"${productName}" deleted from catalogue`, 'success');
      loadCatalogueData();
    }, 'Delete product', true);
  }

  // ─── IMPORT SKUs ─────────────────────────────────────────────────
  function showImport() {
    ui().openModal('Import SKUs — Product catalogue', `
      <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i>
        <span>This imports product definitions into the catalogue only. No stock is created.</span>
      </div>
      <div class="ims__btn-group" style="margin:12px 0">
        <button class="ims__btn ims__btn--secondary" onclick="window.IMS_INVENTORY.downloadTemplate()"><i class="ti ti-download"></i> Download template</button>
      </div>
      <div class="ims__form-group">
        <label class="ims__label">Select CSV file</label>
        <input type="file" accept=".csv" id="ims-inv-import-file" class="ims__input" onchange="window.IMS_INVENTORY.previewImport(this)">
      </div>
      <div id="ims-inv-import-preview"></div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" id="ims-inv-commit-btn" style="display:none" onclick="window.IMS_INVENTORY.commitImport()"><i class="ti ti-check"></i> Import SKUs</button>
    `, 'lg');
  }

  function downloadTemplate() {
    util().exportCSV(
      ['SKU', 'Product Name', 'Category', 'Barcode', 'Unit', 'Cost Price', 'Wholesale Price', 'RRP', 'Reorder Threshold', 'Reorder Quantity', 'Default Bin', 'Notes'],
      [['CHR-001', 'Example Chair', 'Furniture', '1234567890', 'each', '10.00', '18.00', '35.00', '10', '50', 'A-51', 'Sample product']],
      'sku_catalogue_template'
    );
  }

  let _invImportRows = [];

  async function previewImport(input) {
    const file = input.files?.[0];
    if (!file) return;
    const text = await file.text();
    const { headers, rows } = util().parseCSV(text);
    const preview = document.getElementById('ims-inv-import-preview');
    const commitBtn = document.getElementById('ims-inv-commit-btn');

    const { data: existingProducts } = await db().select('products', { select: 'id,sku,barcode,name' });
    const existingSkuMap = {}, existingBarcodeMap = {};
    (existingProducts||[]).forEach(p => {
      if (p.sku)     existingSkuMap[p.sku.toUpperCase()] = p.name;
      if (p.barcode) existingBarcodeMap[p.barcode] = { sku: p.sku, name: p.name };
    });

    const skusInFile = {}, barcodesInFile = {};
    _invImportRows = rows.map((row, rowIndex) => {
      const get = col => { const i = headers.indexOf(col); return i >= 0 ? row[i] || '' : ''; };
      const sku     = get('SKU').trim().toUpperCase();
      const name    = get('Product Name').trim();
      const barcode = get('Barcode').trim();
      const warnings = [], errors = [];

      if (!sku)  errors.push('SKU is required');
      if (!name) errors.push('Product name is required');
      if (sku) {
        if (skusInFile[sku] !== undefined) { errors.push(`Duplicate SKU in file (row ${skusInFile[sku]+2})`); } else { skusInFile[sku] = rowIndex; }
        if (existingSkuMap[sku]) warnings.push(`Will update existing: "${existingSkuMap[sku]}"`);
      }
      if (barcode) {
        if (barcodesInFile[barcode] !== undefined) { errors.push(`Duplicate barcode in file (row ${barcodesInFile[barcode]+2})`); } else { barcodesInFile[barcode] = rowIndex; }
        if (existingBarcodeMap[barcode] && existingBarcodeMap[barcode].sku.toUpperCase() !== sku) warnings.push(`Barcode already on SKU: ${existingBarcodeMap[barcode].sku}`);
      }

      return {
        sku, name, barcode,
        category:   get('Category'),
        unit:       get('Unit') || 'each',
        cost:       get('Cost Price')!=='' ? parseFloat(get('Cost Price')) : null,
        wholesale:  get('Wholesale Price')!=='' ? parseFloat(get('Wholesale Price')) : null,
        rrp:        get('RRP')!=='' ? parseFloat(get('RRP')) : null,
        threshold:  get('Reorder Threshold')!=='' ? parseInt(get('Reorder Threshold')) : 10,
        reorderQty: get('Reorder Quantity')!=='' ? parseInt(get('Reorder Quantity')) : 50,
        bin:        get('Default Bin'),
        notes:      get('Notes'),
        errors, warnings,
        valid: errors.length === 0 && !!sku && !!name
      };
    });

    const valid    = _invImportRows.filter(r => r.valid).length;
    const withWarn = _invImportRows.filter(r => r.valid && r.warnings.length).length;
    const invalid  = _invImportRows.filter(r => !r.valid).length;
    const updates  = _invImportRows.filter(r => r.valid && r.warnings.some(w=>w.startsWith('Will update'))).length;

    if (preview) preview.innerHTML = `
      <div class="ims__alert ims__alert--${invalid>0?'warning':'success'}" style="margin-top:12px">
        <i class="ti ti-${invalid>0?'alert-triangle':'check'}"></i>
        <span><strong>${_invImportRows.length} rows</strong> &nbsp;|&nbsp; <span style="color:var(--ims-success)">${valid} valid</span> &nbsp;|&nbsp; <span style="color:var(--ims-accent)">${updates} updates</span> &nbsp;|&nbsp; ${invalid>0?`<span style="color:var(--ims-danger)">${invalid} errors</span>`:'No errors'}</span>
      </div>
      <div class="ims__table-wrap" style="max-height:250px;overflow-y:auto;margin-top:8px">
        <table class="ims__table">
          <thead><tr><th>SKU</th><th>Name</th><th>Barcode</th><th>Wholesale</th><th>RRP</th><th>Status</th></tr></thead>
          <tbody>${_invImportRows.map(r=>`<tr>
            <td>${util().sanitize(r.sku||'—')}</td><td>${util().sanitize(r.name||'—')}</td>
            <td style="font-size:11px">${util().sanitize(r.barcode||'—')}</td>
            <td>${r.wholesale!==null?util().formatCurrency(r.wholesale):'—'}</td>
            <td>${r.rrp!==null?util().formatCurrency(r.rrp):'—'}</td>
            <td>${r.errors.length?`<span class="ims__pill ims__pill--danger" title="${util().sanitize(r.errors.join(', '))}">✗ ${util().sanitize(r.errors[0])}</span>`:r.warnings.length?`<span class="ims__pill ims__pill--warning" title="${util().sanitize(r.warnings.join(', '))}">⚠ ${util().sanitize(r.warnings[0])}</span>`:'<span class="ims__pill ims__pill--success">✓ New</span>'}</td>
          </tr>`).join('')}
          </tbody>
        </table>
      </div>`;

    if (commitBtn) commitBtn.style.display = valid > 0 ? 'inline-flex' : 'none';
  }

  async function commitImport() {
    const valid = _invImportRows.filter(r => r.valid);
    if (!valid.length) return;
    let created = 0, updated = 0;
    const client = window.supabase.createClient(window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY);
    const commitBtn = document.getElementById('ims-inv-commit-btn');
    const preview = document.getElementById('ims-inv-import-preview');
    if (commitBtn) { commitBtn.disabled = true; commitBtn.innerHTML = '<i class="ti ti-loader-2 ims__spin"></i> Importing...'; }
    let done = 0;
    const total = valid.length;
    const updateProgress = () => {
      const pct = Math.round((done/total)*100);
      if (preview) preview.innerHTML = `<div style="margin-top:12px"><div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:4px"><span>Importing ${done} of ${total}...</span><span>${pct}%</span></div><div style="background:var(--ims-border);border-radius:999px;height:8px"><div style="background:var(--ims-primary);width:${pct}%;height:8px;border-radius:999px;transition:width 0.2s"></div></div></div>`;
    };
    updateProgress();
    for (const row of valid) {
      const { data: existing } = await db().select('products', { eq: { sku: row.sku }, maybeSingle: true });
      let productId;
      if (existing) {
        await db().update('products', existing.id, { name: row.name, category: row.category||null, barcode: row.barcode||null, unit: row.unit, reorder_threshold: row.threshold, reorder_quantity: row.reorderQty, default_bin: row.bin||null, notes: row.notes||null });
        productId = existing.id; updated++;
      } else {
        const { data, error } = await db().insert('products', { sku: row.sku, name: row.name, category: row.category||null, barcode: row.barcode||null, unit: row.unit, reorder_threshold: row.threshold, reorder_quantity: row.reorderQty, default_bin: row.bin||null, notes: row.notes||null });
        if (!error) { productId = data.id; created++; }
      }
      done++;
      updateProgress();
      if (productId) {
        const priceUpdates = [
          row.cost !== null ? { price_type: 'cost', price: row.cost } : null,
          row.wholesale !== null ? { price_type: 'wholesale', price: row.wholesale } : null,
          row.rrp !== null ? { price_type: 'rrp', price: row.rrp } : null,
        ].filter(Boolean);
        for (const pu of priceUpdates) {
          await client.from('product_prices').delete().eq('product_id', productId).eq('price_type', pu.price_type).is('platform_id', null);
          await client.from('product_prices').insert({ product_id: productId, platform_id: null, price_type: pu.price_type, price: pu.price });
        }
      }
    }
    ui().closeModal();
    ui().toast(`Import complete: ${created} added, ${updated} updated`, 'success');
    _invImportRows = [];
    loadCatalogueData();
  }

  // ─── EXPORT ──────────────────────────────────────────────────────
  async function exportProducts() {
    const { data: products } = await db().select('products', { order: { col: 'name' } });
    if (!products?.length) { ui().toast('No products to export', 'warning'); return; }
    const priceMap = {};
    await Promise.all(products.map(async p => {
      const [cost, wholesale, rrp] = await Promise.all([
        canSeeCost() ? db().getProductPrice(p.id, 'cost') : Promise.resolve(null),
        db().getProductPrice(p.id, 'wholesale'),
        db().getProductPrice(p.id, 'rrp')
      ]);
      priceMap[p.id] = { cost, wholesale, rrp };
    }));
    const headers = canSeeCost()
      ? ['SKU','Name','Category','Barcode','Unit','Cost Price','Wholesale Price','RRP','Reorder Threshold','Default Bin']
      : ['SKU','Name','Category','Barcode','Unit','Wholesale Price','RRP','Reorder Threshold','Default Bin'];
    const rows = products.map(p => {
      const pr = priceMap[p.id] || {};
      return canSeeCost()
        ? [p.sku, p.name, p.category||'', p.barcode||'', p.unit||'each', pr.cost??'', pr.wholesale??'', pr.rrp??'', p.reorder_threshold||10, p.default_bin||'']
        : [p.sku, p.name, p.category||'', p.barcode||'', p.unit||'each', pr.wholesale??'', pr.rrp??'', p.reorder_threshold||10, p.default_bin||''];
    });
    util().exportCSV(headers, rows, 'product_catalogue');
  }

  // ─── BINDINGS ────────────────────────────────────────────────────
  window.addEventListener('ims:panel', e => {
    if (e.detail.panel === 'inventory') { initTabs(); loadCatalogue(); }
  });

  window.IMS_INVENTORY = {
    load: loadCatalogue, initTabs, loadCatalogue, loadCatalogueData,
    deleteSKU, onAdjTypeChange,
    loadStock, loadStockData, openSKU,
    showSKUForm, saveSKU,
    addBoxRow, removeBoxRow, updateVolWt,
    showAddStockForm, onProductSelected, saveAddStock, switchToAddStock,
    showAdjustStock, saveAdjustment,
    showBulkStockImport, downloadStockTemplate, previewBulkStock, commitBulkStock,
    managePlatformPrices, savePlatformPrices,
    showImport, downloadTemplate, previewImport, commitImport, exportProducts,
    editProduct: showSKUForm, adjustStock: showAdjustStock
  };
})();
